var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.5 29.58c-10.4-.17-20.2 6.63-19.4 21.22l40 176.3-17.4 4c-12.9-51.9-25.1-109.6-36.8-162.88-4.4-18.3-43.7-16.02-38.3 11.98 16.3 83.5 28.3 166.2 43.2 247.4-10-24.7-38.9-39.5-58.2-53-24.8-17.3-58.3-22.1-76.62 2.3-8.64 9.3 48.42 28.9 77.02 78.5 15.3 44.6 47.2 62.6 77.6 80.9l7.3 59H371l1.2-44.8s17.6-18.6 19.8-31.4c8.4-48.3 3.3-148.1 3.3-148.1 13-45.5 34.2-95.9 47.2-146.7 9.2-36-26.7-46.63-33-30.87L356 241l-16.8-6 55.9-154.18c6-33.18-27.2-39.22-40.7-11.86-24.9 54.94-47.2 147.24-56.9 146.14-8.4-.9-31.1-98.7-43.1-167.32-2.1-11.74-12.2-18.04-21.9-18.2z",
    fill: "#fff",
    fillOpacity: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpock);
export default __webpack_public_path__ + "static/media/spock.50b2e31f7ac6f13c49b000edbd21ecbe.svg";
export { ForwardRef as ReactComponent };